/**
 * kc-story-chapters
 * Vanilla JS ARIA-tabs behaviour for the "Vår historia" chapters section.
 * Supports several instances on one page and re-initialises on theme-editor
 * section/block events.
 */
(function () {
	'use strict';

	function initInstance(root) {
		if (!root || root.__kcChaptersInit) return;
		root.__kcChaptersInit = true;

		var dataScript = root.querySelector('[data-kc-chapters-data]');
		var chapters = [];
		try {
			chapters = JSON.parse(dataScript.textContent);
		} catch (e) {
			chapters = [];
		}
		if (!chapters.length) return;

		var panel = root.querySelector('[data-kc-panel]');
		var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-kc-tab]'));
		var counter = root.querySelector('[data-kc-counter]');
		var title = root.querySelector('[data-kc-title]');
		var body = root.querySelector('[data-kc-body]');
		var images = Array.prototype.slice.call(root.querySelectorAll('[data-kc-image]'));
		var prevBtn = root.querySelector('[data-kc-prev]');
		var nextBtn = root.querySelector('[data-kc-next]');

		var total = chapters.length;
		var activeIndex = 0;

		function pad(n) {
			return n < 10 ? '0' + n : String(n);
		}

		function setActive(index, focusTab) {
			activeIndex = ((index % total) + total) % total;
			var chapter = chapters[activeIndex];
			if (!chapter) return;

			if (panel) {
				panel.style.setProperty('--bg', chapter.bg);
				panel.style.setProperty('--fg', chapter.fg);
			}
			if (counter) counter.textContent = pad(activeIndex + 1) + ' / ' + pad(total);
			if (title) title.textContent = chapter.title;
			if (body) body.innerHTML = chapter.body;

			tabs.forEach(function (tab, i) {
				var isActive = i === activeIndex;
				tab.classList.toggle('is-active', isActive);
				tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
				tab.setAttribute('tabindex', isActive ? '0' : '-1');
				if (isActive && focusTab) tab.focus();
			});

			images.forEach(function (img, i) {
				img.classList.toggle('is-active', i === activeIndex);
			});
		}

		tabs.forEach(function (tab, i) {
			tab.addEventListener('click', function () {
				setActive(i, false);
			});
		});

		var tabsWrap = root.querySelector('[data-kc-tabs]');
		if (tabsWrap) {
			tabsWrap.addEventListener('keydown', function (event) {
				if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
				event.preventDefault();
				var dir = event.key === 'ArrowRight' ? 1 : -1;
				setActive(activeIndex + dir, true);
			});
		}

		if (prevBtn) {
			prevBtn.addEventListener('click', function () {
				setActive(activeIndex - 1, false);
			});
		}

		if (nextBtn) {
			nextBtn.addEventListener('click', function () {
				setActive(activeIndex + 1, false);
			});
		}

		root.__kcSetActiveByBlockId = function (blockId) {
			var index = tabs.findIndex(function (tab) {
				return tab.getAttribute('data-block-id') === blockId;
			});
			if (index > -1) setActive(index, false);
		};

		setActive(0, false);
	}

	function initAll(context) {
		var scope = context || document;
		scope.querySelectorAll('[data-kc-chapters]').forEach(initInstance);
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', function () {
			initAll();
		});
	} else {
		initAll();
	}

	document.addEventListener('shopify:section:load', function (event) {
		initAll(event.target);
	});

	document.addEventListener('shopify:block:select', function (event) {
		var root = event.target.closest('[data-kc-chapters]');
		if (root && typeof root.__kcSetActiveByBlockId === 'function') {
			root.__kcSetActiveByBlockId(event.detail.blockId);
		}
	});
})();
